"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpFormDatetime = void 0;
const _ = __importStar(require("lodash"));
const form_datetime_html_1 = __importDefault(require("./form-datetime.html"));
const vue_property_decorator_1 = require("vue-property-decorator");
const form_input_base_1 = require("./form-input-base");
const lang_hu = require('vue2-datepicker/locale/es/hu');
const lang_en = require('vue2-datepicker/locale/es/en');
const VALUE_TYPES = {
    date: 'YYYY-MM-DD',
    datetime: 'YYYY-MM-DD HH:mm',
    year: 'YYYY',
    month: 'MM',
    time: 'HH:mm',
    week: 'ww'
};
let ItpFormDatetime = class ItpFormDatetime extends (0, vue_property_decorator_1.Mixins)(form_input_base_1.FormInputBase) {
    open;
    type;
    hackData() {
        return {
            lang: getLang(this.$app),
            format: getFormat(this.type, this.$app),
            formatter: getFormatter(this.$app),
            valueType: getValueType(this.type),
            open: false
        };
    }
    handleClick(evt) {
        if (_.get(evt, 'target.tagName') !== 'INPUT') {
            this.open = true;
        }
    }
    get inputClass() {
        return `form-control form-control-${this.size}`;
    }
};
exports.ItpFormDatetime = ItpFormDatetime;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'date' }),
    __metadata("design:type", String)
], ItpFormDatetime.prototype, "type", void 0);
exports.ItpFormDatetime = ItpFormDatetime = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: form_datetime_html_1.default,
        inject: {
            componentContext: 'componentContext',
            formContext: { default: null }
        }
    })
], ItpFormDatetime);
function getValueType(type) {
    return _.get(VALUE_TYPES, type);
}
function getLang(app) {
    if (app.i18n.locale === 'hu') {
        return lang_hu.default;
    }
    return lang_en.default;
}
function getFormat(type, app) {
    if (type === 'date') {
        return app.i18n.dateFormat;
    }
    return _.get(VALUE_TYPES, type);
}
function getFormatter(app) {
    const i18n = app.i18n;
    return {
        stringify(value) {
            return i18n.stringifyDate(value);
        },
        parse(value) {
            return i18n.parseDate(value);
        },
        getWeek(value) {
            return i18n.getWeek(value);
        }
    };
}
//# sourceMappingURL=form-datetime.js.map